export { productDataAdapter } from './adapters';
